import { css } from '@recruit-robin/robin-theme/web-styles';

import ztTalkBlackUrl from '../assets/fonts/zt-talk-black.otf';
import ztTalkBoldSemiExpandedUrl from '../assets/fonts/zt-talk-bold-semi-expanded.ttf';
import ztTalkSemiExpandedUrl from '../assets/fonts/zt-talk-semi-expanded.otf';

/**
 * ZT Talk, the tenant's typeface, declared the way the Adecco client kit declares it: one
 * family, three faces, told apart by weight alone.
 *
 * The faces differ in width as well as weight — 400 and 700 are Semi Expanded, 900 is Black
 * at normal width — so a role picks its face with `font-weight` and nothing else. The 600
 * that `item` and `meta` ask for has no face of its own; the browser resolves it up to the
 * 700, which is what the kit renders too.
 *
 * Mounted by `ApplyStage` as a `Global`, so the family exists only while the flow is on
 * screen and nothing outside it can pick it up. The files are only fetched once text in the
 * family renders.
 */
export const applyFlowFontFacesCss = css`
  @font-face {
    font-family: 'ZT Talk';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${ztTalkSemiExpandedUrl}) format('opentype');
  }

  @font-face {
    font-family: 'ZT Talk';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${ztTalkBoldSemiExpandedUrl}) format('truetype');
  }

  @font-face {
    font-family: 'ZT Talk';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(${ztTalkBlackUrl}) format('opentype');
  }
`;
